import React, { createElement } from 'react';
import styled from 'styled-components';
const verticalAlignment = `
  &&&&& {
    display: flex;
    align-items: start;
  }
  &&&&& span {
    flex: 1;
    margin-left: 10px;
  }
`;
const VerticallyAlignedH1 = styled.h1`
  ${verticalAlignment}
`;
const VerticallyAlignedH2 = styled.h2`
  ${verticalAlignment}
`;
const VerticallyAlignedH3 = styled.h3`
  ${verticalAlignment}
`;
const VerticallyAlignedH4 = styled.h4`
  ${verticalAlignment}
`;
const VerticallyAlignedH5 = styled.h5`
  ${verticalAlignment}
`;
const VerticallyAlignedH6 = styled.h6`
  ${verticalAlignment}
`;
export const Heading = props => {
  var _children$, _children$$props;

  const {
    children,
    level
  } = props; // check to see if the first child is an image

  if ((_children$ = children[0]) !== null && _children$ !== void 0 && (_children$$props = _children$.props) !== null && _children$$props !== void 0 && _children$$props.src) {
    // if the first child is an image and there is only one child
    // we return a fragment with the image so as not to wrap in tags
    if (children.length === 1) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    } // we seperate the image and children for layout purposes in a flex container


    const image = children.shift();
    const content = [image, /*#__PURE__*/React.createElement("span", {
      key: "child"
    }, children)];
    const result = {
      1: /*#__PURE__*/React.createElement(VerticallyAlignedH1, null, content),
      2: /*#__PURE__*/React.createElement(VerticallyAlignedH2, null, content),
      3: /*#__PURE__*/React.createElement(VerticallyAlignedH3, null, content),
      4: /*#__PURE__*/React.createElement(VerticallyAlignedH4, null, content),
      5: /*#__PURE__*/React.createElement(VerticallyAlignedH5, null, content),
      6: /*#__PURE__*/React.createElement(VerticallyAlignedH6, null, content)
    }[level] || /*#__PURE__*/React.createElement(VerticallyAlignedH6, null, content);
    return result;
  }

  return /*#__PURE__*/createElement(`h${level}`, {
    children
  });
};